import { NgModule } from '@angular/core';
import { BehaviorLicenseMessageComponent } from './behavior-license-message.component';

@NgModule({
  declarations: [ BehaviorLicenseMessageComponent ],
  imports: [],
  exports: [BehaviorLicenseMessageComponent]
})
export class BehaviorLicenseMessageModule {}
